import React from 'react';
import Modal from 'src/modules/shared/modal/components/modal';

const PAMModal = () => (
  <Modal
    size="lg"
    title="We believe connecting people online can help them achieve better health outcomes"
  >
    <div className="home__modal-content">
      <p>
        The Patient Activation Measure (PAM) is a scientifically tested questionnaire, measuring someone’s knowledge, skill and confidence in managing their own health<sup>1</sup>. The PAM is scored on a scale of 0 to 100 and the scores assign people into one of four levels of increasing ‘activation’. Level 1 is someone with low knowledge, skills and confidence in managing their own health, and at the other end Level 4 is someone with very high knowledge, skills and confidence.
      </p>
      <p>
        In a research study which followed newly registered users to HealthUnlocked for a period of 12 weeks, it was found that nearly 30% of those in the low activation levels (1-2) moved to the high activation levels (3-4). This increase in activation translates to adoption of healthy behaviour, better clinical outcomes and lower rates of healthcare utilisation<sup>2,3</sup>.
      </p>
      <p>
        This data was observed across multiple disease areas, have been presented publicly in conferences, and form part of a publication currently in submission. Our next series of studies will look in more detail at measuring the ‘HealthUnlocked effect’ in single disease areas.
      </p>
      <p>
        <a href="mailto:research@healthunlocked.com?subject=PAM%20Research">Contact us</a> to find out more about our research
      </p>
      <div className="home__modal-super-text" >
        <p>
          <sup>1</sup> Hibbard, J; Stockard, J; Mahoney, ER; Tusler, M. (2004). Development of the Patient Activation Measure (PAM): Conceptualizing and measuring activation in patients and consumers. Health Services Research. 39(4), 1005–10026. doi:10.1111/j.1475-6773.2004.00269.x
        </p>
        <p>
          <sup>2</sup> Hibbard, J; Greene, J.(2013). What The Evidence Shows About Patient Activation: Better Health Outcomes And Care Experiences; Fewer Data on Costs. Health Affairs. 32(2), 207-214. doi: 10.1377/hlthaff.2012.1061
        </p>
        <p>
          <sup>3</sup> Greene, J; Hibbard, J.H; Sacks, R; Overton, V; Parotta, C.D. (2015). When Patient Activation Levels Change, Health Outcomes And Costs Change, Too. Health Affairs. 34(3), 431-437. doi: 10.1377/hlthaff.2014.0452
        </p>
      </div>
    </div>
  </Modal>
);

export default PAMModal;



// WEBPACK FOOTER //
// ./src/modules/home/components/PAMmodal.js